import type { JSX } from 'react';
import { Box, styled } from '@mui/material';
import { LABEL_WIDTH, TIMELINE_COLOURS } from '@/constants/PatientDashboard/patientTimeline';

const CrosshairOverlay = styled(Box)({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: `${LABEL_WIDTH}px`,
  right: 0,
  zIndex: 2,
  pointerEvents: 'none',
});

const CrosshairLine = styled(Box)({
  position: 'absolute',
  top: 0,
  bottom: 0,
  borderLeft: `1px dashed ${TIMELINE_COLOURS.crosshairLine}`,
});

interface IProps {
  pct: number;
}

export default function AxisCrosshair({ pct }: IProps): JSX.Element {
  return (
    <CrosshairOverlay>
      <CrosshairLine style={{ left: `${pct}%` }} />
    </CrosshairOverlay>
  );
}
